import React from "react";

export default function ComplianceScoreCard({ title, score, weight, description, status, icon, color }) {
  const getBadgeStyle = (statusStr) => {
    switch (statusStr) {
      case "HEALTHY":
      case "EXCELLENT":
      case "VERIFIED":
      case "COMPLIANT":
        return { bg: "#ecfdf5", text: "#065f46", border: "#a7f3d0" };
      case "ACTIVE_HOLD":
        return { bg: "#fef3c7", text: "#92400e", border: "#fde68a" };
      case "MODERATE_RISK":
        return { bg: "#fff7ed", text: "#c2410c", border: "#ffedd5" };
      default:
        return { bg: "#f1f5f9", text: "#475569", border: "#e2e8f0" };
    }
  };

  const badge = getBadgeStyle(status);

  return (
    <div style={{
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      padding: "20px",
      border: "1px solid #e2e8f0",
      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)",
      display: "flex",
      flexDirection: "column",
      justify: "space-between",
      position: "relative",
      overflow: "hidden"
    }}>
      {/* Top Bar Accent */}
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: "4px",
        backgroundColor: color || "#4f46e5"
      }} />

      <div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "18px" }}>{icon || "🛡️"}</span>
            <h4 style={{ fontSize: "14px", fontWeight: "700", color: "#1e293b", margin: 0, textTransform: "capitalize" }}>
              {title}
            </h4>
          </div>
          <span style={{
            fontSize: "11px",
            fontWeight: "700",
            padding: "2px 8px",
            borderRadius: "12px",
            backgroundColor: badge.bg,
            color: badge.text,
            border: `1px solid ${badge.border}`
          }}>
            {status}
          </span>
        </div>

        <div style={{ display: "flex", alignItems: "baseline", gap: "6px", marginBottom: "8px" }}>
          <span style={{ fontSize: "32px", fontWeight: "800", color: "#0f172a" }}>
            {score}%
          </span>
          <span style={{ fontSize: "12px", color: "#64748b", fontWeight: "600" }}>
            (Weight: {weight})
          </span>
        </div>

        {/* Dynamic Progress Bar */}
        <div style={{ width: "100%", backgroundColor: "#f1f5f9", borderRadius: "9999px", height: "8px", marginBottom: "12px" }}>
          <div style={{
            width: `${Math.min(100, Math.max(0, score))}%`,
            height: "100%",
            borderRadius: "9999px",
            backgroundColor: color || "#4f46e5",
            transition: "width 0.6s ease-in-out"
          }} />
        </div>

        <p style={{ fontSize: "12px", color: "#64748b", margin: 0, lineHeight: "1.4" }}>
          {description}
        </p>
      </div>
    </div>
  );
}
